import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'

momentDurationFormatSetup(moment as any)

export const monthDayYear = (date: Date) => {
  return moment(date).format('MMM D, YYYY')
}

export const monthYear = (date: Date) => {
  return moment(date).format('MMM YYYY')
}

export const localShortDate = (date: Date) => {
  return moment(date).format('l')
}

export const calculateDuration = (start: string, end: string) => {
  const duration = moment.duration(moment(end).diff(moment(start)))
  return duration.format('D [day], H [hour and] m [min]')
}

export const calcHumanReadableTimeAgo = (date: Date) => {
  return `${moment.duration(moment(date).diff(moment())).humanize()} ago`
}
